import script from "./Tutorial.vue?vue&type=script&setup=true&lang=js"
export * from "./Tutorial.vue?vue&type=script&setup=true&lang=js"

import "./Tutorial.vue?vue&type=style&index=0&id=5bf3953a&scoped=true&lang=css"

import exportComponent from "D:\\Desktop\\项目\\xiongxi\\vue-notus-main\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bf3953a"]])

export default __exports__